module.exports = __webpack_public_path__ + "static/media/hills.28d0aa8a.svg";